import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFound = () => {
  const {t}=useTranslation("")
  return (
    <div className="page404Wrapper">
      <div className="page404Content text-center">
        <img
          src="../../../assets/images/404.png"
          alt=""
          className="mx-auto d-block img-fluid mb-5"
        />
        <h1>404</h1>
        <p className="mb-4">{t("AuthPages.heading")}</p>
        <Link to="/" className="fontsize-16 fw700 color-active">{t("AuthPages.BackToHome")}</Link>
      </div>
    </div>
  );
};

export default NotFound;
